import {Injectable} from '@angular/core';
import {DbBaseRepository} from "../../common.module/util/db.base.repository";
import {openDb, deleteDb, DB} from 'idb';
@Injectable()
export class LoginRepositoryConsumos extends DbBaseRepository {
}
